module.exports = __webpack_public_path__ + "static/media/japanese-categories.1633c310.jpg";